export default {
      id: "bigFilters-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#bigFilters-usage",
      toString: function () {
        return this.url;
      }
    }